module.exports = __webpack_public_path__ + "img/fotoDefault.e22b94fc.svg";